import UserImpersonationComponent from './UserImpersonation';

const UserImpersonation = UserImpersonationComponent;

export default UserImpersonation;
